import AboutContainer from "../../../Components/Bonus/About";

const About = () => {
  return <AboutContainer />;
};

export default About;
